import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  icon: {
    margin: "auto",
    padding: 5,
    elevation: 4,
    shadowRadius: 15,
    borderRadius: 25,
    shadowOpacity: 0.3,
    backgroundColor: "$scroll_indicator",
  },
});
